import { notifyServiceWorkerUpdate } from '@rr-crm/shared/hooks';
import { answerServiceWorkerTakeoverPing } from '@rr-crm/shared/sw';
import { registerSW } from 'virtual:pwa-register';

/**
 * Overnight D4 — prompt-mode registration.
 *
 * `vite.config.ts` sets `registerType: 'prompt'` (with no skipWaiting /
 * clientsClaim), so a newly installed worker WAITS instead of taking over.
 * The plugin calls `onNeedRefresh` when that happens; we hand the resulting
 * `updateSW` to the shared store and `RrUpdatePrompt` shows "A new version is
 * available. Reload". Only that click activates the worker and reloads.
 *
 * Before this, `autoUpdate` reloaded the page on the worker's `activated`
 * event, which on the first load after every deploy wiped the first click or
 * the first characters typed.
 *
 * RIG-625 — one-time takeover for pages that cannot show the prompt. A new
 * worker pings every open page at install; this page answers "I can show
 * the prompt", so the worker keeps waiting. Pages built before D4 never
 * answer, and the worker takes over so they are not stranded. The answer
 * is wired BEFORE registering, so the listener exists before any ping.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return;
  answerServiceWorkerTakeoverPing();
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      // Staging walk item 8: applied at once if the person has not touched
      // the page yet; otherwise the in-flow "new version" banner asks.
      notifyServiceWorkerUpdate(() => updateSW(true), { applyIfUntouched: true });
    },
  });
}
